<div class="start-container">
  <router-outlet></router-outlet>
  <ngx-spinner name="main"
               size="medium"
               bdColor="rgba(0,0,0,0.2)"></ngx-spinner>
</div>